/*export const statusColors = {
	new: '#e30613',
	confirmed: 'rgb(84,130,53)',
	hold: '#4978b7',
	finalised: '#db6413',
	invoiced: '#ffc000',
	canceled: '#363636',
	rejected: '#6e6868'
}*/

export const statusColors = {
	new: 'rgb(198, 40, 40)',
	confirmed: 'rgb(76, 175, 80)',
	hold: '#4978b7',
	finalised: 'rgb(33, 150, 243)',
	invoiced: '#ffc000',
	canceled: 'rgb(33, 33, 33)',
	rejected: 'rgb(158, 158, 158)'
}

// ['rgb(198, 40, 40)', 'rgb(76, 175, 80)', 'rgb(158, 158, 158)', 'rgb(33, 150, 243)', 'rgb(33, 33, 33)']


// WEBPACK FOOTER //
// ./src/utils/colors.js